export function getPrice (questions, answers) {
  let price = 0
  let questionIndex = 0
  let multiplier = 1
  for (const answerIndex of answers) {
    const answer = questions[questionIndex].answers[answerIndex]
    if (answer.costMultiplier !== undefined) {
      multiplier *= answer.costMultiplier
    } else if (answer.cost !== undefined) {
      price += answer.cost
    } else {
      price += answer.costAndMultiplier[0]
      multiplier *= answer.costAndMultiplier[1]
    }
    questionIndex++
  }

  const finalPrice = price * multiplier
  const roundToValue = finalPrice < 20000 ? 100 : 500
  return Math.round(finalPrice / roundToValue) * roundToValue
}
